import basic from  './basic'
import service from  './service'
// import module from  './module'

const es = {
  ...basic,
  ...service,
  // ...module,
}

export default es
